import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow2",
  "use": "icon-arrow2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow2\"><path d=\"M274.048 438.656A32 32 0 0 1 296.704 384h430.592a32 32 0 0 1 22.656 54.656l-192.64 192.64a64 64 0 0 1-90.56 0l-192.64-192.64z\" p-id=\"5397\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol